import { type Edge } from '@xyflow/react';

import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import { type EdgeData } from '../components/node-components/LabelEdge';
import { type CustomNode } from '../node';

export const ROOT_NODE_ID = 'rootNode';

export const getInitialEdge = (
  sourceId: string,
  targetId: string,
  t: TGlobalFunctionTyped,
): Edge<EdgeData> => ({
  id: 'initialEdge',
  source: sourceId,
  target: targetId,
  type: 'labelEdge',
  data: {
    labelText: t('approvalWorkflows.labelEdge.orElse'),
    labelVariant: 'ocean',
    icon: 'circle-information',
  },
});

export const getStandardApprovalFlowNode = (
  nodeId: string,
  schemeId: string,
): CustomNode => {
  return {
    id: nodeId,
    position: { x: 0, y: 0 },
    draggable: false,
    type: 'standardApprovalFlowNode',
    data: {
      schemeId,
    },
  };
};

export const rootNode: CustomNode = {
  id: ROOT_NODE_ID,
  position: { x: 0, y: 0 },
  draggable: false,
  type: 'labelNode',
  data: {
    nodeType: 'labelNode',
  },
};
